
import { Component, Vue, Prop } from "vue-property-decorator";
import httpClient from "../../store/httpClient";
import {
	CustomerStatementDto,
	CustomerStatementEntryDto,
	CustomerStatementEntryType,
} from "@/dtos/customerStatementDto";

@Component
export default class CustomerSettlement extends Vue {
	@Prop()
	private customerId!: string;
	private loading: boolean = false;
	private statement: CustomerStatementDto = new CustomerStatementDto();
	private statementHeaders = [
		{ text: "Datum", value: "date", align: "left", sortable: false },
		{ text: "Typ", value: "type", align: "left", sortable: false },
		{ text: "Beschreibung", value: "description", align: "left", sortable: false },
		{ text: "Auftrag", value: "orderId", align: "left", sortable: false },
		{ text: "Soll", value: "debit", align: "right", sortable: false },
		{ text: "Haben", value: "credit", align: "right", sortable: false },
		{ text: "Saldo", value: "balance", align: "right", sortable: false },
	];

	private async mounted() {
		await this.loadStatement();
	}

	private get sortedEntries(): CustomerStatementEntryDto[] {
		// Neueste Buchung zuoberst. Der laufende Saldo je Zeile bleibt korrekt,
		// da er chronologisch berechnet wurde - die oberste Zeile entspricht
		// damit dem Gesamtsaldo.
		return this.statement.entries.slice().reverse();
	}

	private async loadStatement() {
		try {
			this.loading = true;
			const response = await httpClient().get(
				`Customer/GetCustomerStatement?customerId=${this.customerId}`
			);
			this.statement = response.data;
		} catch (err) {
			console.log("Failed getting customer statement.");
		} finally {
			this.loading = false;
		}
	}

	private entryTypeLabel(type: CustomerStatementEntryType): string {
		switch (type) {
			case CustomerStatementEntryType.Invoice:
				return "Rechnung";
			case CustomerStatementEntryType.Payment:
				return "Zahlung";
			case CustomerStatementEntryType.CreditNote:
				return "Gutschrift";
			default:
				return "";
		}
	}

	private formatDebit(item: CustomerStatementEntryDto): string {
		// Rechnungen werden im Soll geführt - auch wenn der Betrag 0.00 ist.
		return item.type === CustomerStatementEntryType.Invoice
			? this.formatAmount(item.debit)
			: "";
	}

	private formatCredit(item: CustomerStatementEntryDto): string {
		// Zahlungen und Gutschriften werden im Haben geführt - auch bei 0.00.
		return item.type === CustomerStatementEntryType.Invoice
			? ""
			: this.formatAmount(item.credit);
	}

	private formatDate(date: Date | string): string {
		if (!date) return "";
		return new Date(date).toLocaleDateString("de-CH");
	}

	private formatAmount(amount: number): string {
		return amount.toLocaleString("de-CH", {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		});
	}

	private back() {
		this.$router.go(-1);
	}
}
